import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import About from './pages/About'
import Chart from './pages/Chart'
import NFT from './pages/NFT'
import CreateMarketplace from './pages/CreateMarketplace'
import Community from './pages/Community'
import Incinerator from './pages/Incinerator'
import BattleArena from './pages/BattleArena'
import MandoxExchange from './pages/MandoxExchange'
import SmartContractAudit from './pages/SmartContractAudit'

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<About />} />
          <Route path="/chart" element={<Chart />} />
          <Route path="/nft" element={<NFT />} />
          <Route path="/battle-arena" element={<BattleArena />} />
          <Route path="/create-marketplace" element={<CreateMarketplace />} />
          <Route path="/incinerator" element={<Incinerator />} />
          <Route path="/mandox-exchange" element={<MandoxExchange />} />
          <Route path="/community" element={<Community />} />
          <Route path="/smart-contract-audit" element={<SmartContractAudit />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  )
}

export default App
